<script setup lang="ts">
import { computed, type PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import TempIcon from '../../icons/TempIcon.vue';

const props = defineProps({
  value: {
    type: Number as PropType<number | null>,
    required: false,
    default: null,
  },
  unit: {
    type: String,
    required: false,
    default: '°'
  },
});

const { t } = useI18n();

// A port with no sensor has no reading at all; showing 0 would read as a
// genuine measurement.
const display = computed(() =>
  props.value === null ? t('common.notAvailable') : `${props.value}${props.unit}`
);
</script>

<template>
  <div class="flex flex-row items-center h-full w-full justify-center">
    <TempIcon class="h-9" />
    <div class="ml-3 text-foreground text-2xl md:text-3xl font-light">
      {{ display }}
    </div>
  </div>
</template>
